export const facilityDropdownData = [
  { label: "WHD-1", value: "whd_1" },
  { label: "WHJ-1", value: "whj_1" },
  { label: "WHN-1", value: "whn_1" },
  { label: "WHD-2", value: "whd_2" },

];

export const favoriteDropdownData = [
  { value: "fav1", label: "ASN Management" },
  { value: "fav2", label: "Purchase Orders" },
  { value: "fav3", label: "Inventory" }
];
export const helpdropdownData = [
  // { value: "help1", label: "User Guide", path: "/user-guide" },
  { value: "help1" ,label: "User Guide", path: "user_guide", type: "trainingsmall",},
  { value: "settings", label: "User Settings", path: "/settings" },
   { value: "AdminSettings", label: "Admin Settings", path: "/AdminSettings" }
];

// utils/headerDropdownData.js
export const helpdropdownDataold = [
  { label: "User Guide", path: "user_guide", type: "trainingsmall", value: "help1" },
  // or if you already have an external URL:
  { label: "Docs (Online)", path: "https://docs.example.com/guide", value: "help2" },
  // ...
];


export const savedViewsDropdownData = [
  { value: "view1", label: "Default View" },
  { value: "view2", label: "Compact View" },
  { value: "view3", label: "Detailed View" }
];

export const toolsDropdownData = [
  { value: "tool1", label: "Import/Export" },
  { value: "tool2", label: "Preferences" },
  { value: "tool3", label: "Advanced Tools" }
];